/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SelectedPendingExamsAliases {
  BUTTON_ADD_SELECTED_PENDING_EXAMS = 'button-add-selected-pending-exams',
  CONTAINER_PANEL_BUTTON_SELECTED_PENDING_EXAMS = 'container-panel-button-selected-pending-exams',
  PANEL_BUTTON_VIEW_SELECTED_PENDING_EXAMS = 'panel-button-view-selected-pending-exams',
  SELECTED_PENDING_EXAMS_CARD = 'selected-pending-exams-card',
  SELECTED_PENDING_EXAMS_DECK = 'selected-pending-exams-deck',
  SELECTED_PENDING_EXAMS_LAYOUT = 'selected-pending-exams-layout',
  SELECTED_PENDING_EXAMS_PANEL = 'selected-pending-exams-panel',
  SELECTED_PENDING_EXAMS_PANEL_CONTENT = 'selected-pending-exams-panel-content',
}
export { SelectedPendingExamsAliases };
